import { Link } from 'react-router-dom';

export const faqTopics: Record<string, any> = {
    'what is this site?': (
        <div>
            <p>
                <span className="text-avenir-db text-light">NFTY </span>
                is a place to buy <span className="text-light">digital ART</span>.
            </p>
            <p>
                <span>Unique and exclusive art, which, thanks to the power of </span>
                <a href="https://en.wikipedia.org/wiki/Non-fungible_token" target="_blank" rel="noreferrer">modern technology</a>,
                <span> cannot be reproduced or duplicated, preserving the</span>
                <span className="text-light"> value </span>
                <span>of the original.</span>
            </p>
            <p>
                We seek out <span className="text-light">timeless</span> pieces made by visionary artists,
                chosen because they express some form of technical proficiency, artistic beauty, emotional power,
                or unique and creative imagination.
            </p>
        </div>
    ),
    'how does it work?': (
        <div>
            <p>This is not a quantity-over-quality operation.</p>
            <p>
                <span>Every day, we </span>
                <a href="https://en.wikipedia.org/wiki/No-reserve_auction" target="_blank" rel="noreferrer">auction off</a>
                <span> a single curated piece of digital art, made by one of our </span>
                <Link to="/artists">partner artists</Link>.
            </p>
            <p>
                At exactly <a href="https://en.wikipedia.org/wiki/Pacific_Time_Zone" target="_blank" rel="noreferrer">00:00:00 Pacific Time</a>,
                a new auction begins, and art enthusiasts from around the world have 24 hours to bid on the item.
            </p>
            <p>
                <span>The auction will</span>
                <span className="text-light"> end </span>
                <span>on the same day at </span>
                <a href="https://en.wikipedia.org/wiki/Pacific_Time_Zone" target="_blank" rel="noreferrer">23:59:59 Pacific Time</a>.
            </p>
            <p>
                The
                <span className="text-light"> highest bid wins </span>
                the auction and immediately receives the item.
            </p>
        </div>
    ),
    'ok, how can I participate?': (
        <div>
            <p>
                <span>In order to bid on items, you will need </span>
                <a href="https://metamask.io/download.html" target="_blank" rel="noreferrer">Metamask</a>
                <span> and a valid </span>
                <a href="https://metamask.io/download.html" target="_blank" rel="noreferrer">Ethereum Wallet</a>.
            </p>
            <p>
                As soon as an auction begins,
                <span className="text-light"> bids are open to anyone </span>
                who wants to participate and are anonymous throughout the auction.</p>
            <p>
                <span>Once submitted, a bid cannot be retracted, and </span>
                <span className="text-light">the highest bid is reflected immediately</span>
                <span> in the current price of the auction.</span>
            </p>
            <p>Once the auction ends, the winner will immediately receive the NFT in their wallet.</p>
            <p>In order to receive physical copy of the item, you will need to <u>contact us directly</u> with a valid mailing address.</p>
        </div>
    ),
    'can i use a credit card instead?': (
        <div>
            <p>At the moment, you cannot use a credit card to bid.</p>
            <p>
                <span>You will need </span>
                <a href="https://metamask.io/download.html" target="_blank" rel="noreferrer">Metamask</a>
                <span> and a valid ethereum wallet.</span>
            </p>
            <p>
                We are trying to make bidding as easy as possible, so this is in our roadmap!
            </p>
        </div>
    ),
    'what is the physical copy?': (
        <div>
            <p>
                We have gone to great lengths to provide a unique,
                <span className="text-light"> custom made 3D portrait frame </span>
                that showcases each artpiece in its unique way.
                <span> Check out some </span>
                <a href="/" target="_blank" rel="noreferrer">pictures on instagram!</a>
            </p>
            <p>
                As an auction winner, you are entitled to receive your physical copy of the art piece
                as a part of the auction winnings, shipping included. You will have
                <span className="text-light"> 90 days </span>from the end of the auction
                to provide us with:
            </p>
            <ul>
                <li>Proof that you are rightful owner of the wallet </li>
                <li>A valid mailing address within the 50 US States (international shipping not available yet!)</li>
            </ul>
        </div>
    ),
    'how do i know this isn\'t a scam?': (
        <div>
            <p>We lament the unfortunate number of scams that have made history in the world of crypto, and affirm that they only prevent further adoption.</p>
            <p>
                Our system is driven by a
                <span className="text-light"> smart contract </span>
                , carefully built and thoroughly tested on the ethereum network.
            </p>
            <p>
                <span>We encourage you to view and inspect for yourself the address where </span>
                <a href="https://www.etherchain.org/block/12397982" target="_blank" rel="noreferrer">our auction contract</a>
                <span> exists.</span>
            </p>
            <p>
                We also encourage you to post your winnings to twitter, instagram, or your favorite
                <span> social media site using the tag </span>
                <span className="text-light">#nfty</span>
                <span>.</span>
            </p>
        </div>
    )
};

export const defaultItem = faqTopics['what is this site?'];